import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { MentionNodeAttrs } from '@tiptap/extension-mention';
import { getUsersOptions } from 'Store/Activities/Activities.selector';
import MentionUserComponentRender from './MentionUserComponentRender';
import { mentionGroupUsersIds } from '../MentionListUser';

const MentionUserDynamicDisplay: FC<NodeViewProps> = ({ node }) => {
  const { id } = node.attrs as MentionNodeAttrs;
  const isGroupMention = mentionGroupUsersIds.includes(Number(id));
  const groupId = isGroupMention ? Number(id) : undefined;
  const usersOptions = useSelector(getUsersOptions);

  const user = useMemo(() => {
    if (isGroupMention) return undefined;
    return usersOptions.find(user => user.Id === id);
  }, [isGroupMention, usersOptions, id]);

  return (
    <NodeViewWrapper as="span" className="mention-user-wrapper">
      <MentionUserComponentRender
        isGroup={isGroupMention}
        groupId={groupId}
        user={user}
      />
    </NodeViewWrapper>
  );
};

export default MentionUserDynamicDisplay;
